import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ROLE } from '../../enums';
import type { RootState } from '../store';

interface AuthState {
  isAuthenticated: boolean;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  token: string | undefined;
  user: { firstname: string; lastname: string; email: string; role: ROLE } | undefined;
  department: { id: string; name: string } | undefined;
}

const initialState: AuthState = {
  isAuthenticated: false,
  isAdmin: false,
  isSuperAdmin: false,
  token: undefined,
  user: undefined,
  department: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<AuthState>) => {
      const { token, user, department, isAdmin = false, isSuperAdmin = false } = action.payload;

      return { ...state, token, user, department, isAdmin, isSuperAdmin, isAuthenticated: true };
    },
    logout: (state) => {
      return {
        ...state,
        token: undefined,
        user: undefined,
        department: undefined,
        isAdmin: false,
        isSuperAdmin: false,
        isAuthenticated: false,
      };
    },
  },
});

export const { login, logout } = authSlice.actions;

export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectIsAdmin = (state: RootState) => state.auth.isAdmin;
export const selectIsSuperAdmin = (state: RootState) => state.auth.isSuperAdmin;
export const selectToken = (state: RootState) => state.auth.token;
export const selectUser = (state: RootState) => state.auth.user;
export const selectDepartment = (state: RootState) => state.auth.department;
